import * as moment from 'moment-timezone';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function convertDateToNgbDate(date: string | undefined | number) {
  const innerDate = moment(date);
  return NgbDate.from({
    day: innerDate.date(),
    month: innerDate.month() + 1,
    year: innerDate.year(),
  }) as NgbDate;
}

export function convertNgbDateDownToExactTime(date: NgbDate) {
  const rightNow = moment();

  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
    hours: rightNow.hours(),
    minutes: rightNow.minutes(),
    seconds: rightNow.seconds(),
  });
}

export function convertNgbDateStructToDate(date: NgbDateStruct) {
  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
  });
}

export function convertStringDateDownToDateFormat(date: NgbDate) {
  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
  }).format('YYYY-MM-DD');
}

export function convertStringDateDownToDateFormatWithUSCentralTime(
  date: NgbDate,
) {
  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
  })
    .tz('America/Chicago') // Set to US Central time
    .startOf('day') // Set to start of day (00:00:00)
    .format('YYYY-MM-DD'); // Format as YYYY-MM-DD
}

export function convertDateToNgbDateStruct(date: Date): NgbDateStruct {
  return {
    year: moment(date).get('year'),
    month: moment(date).get('month') + 1,
    day: moment(date).get('date'),
  };
}
